import Abstract from "../../abstract-view/abstract.js";

export default class TabLink extends Abstract {
  constructor(element, index) {
    super();

    this._element = element;
    this._index = index;

    this._parentElement = null;

    this._clickHandler = this._clickHandler.bind(this);
  }

  getParent() {
    if (!this._parentElement) {
      this._parentElement = this._element.parentElement;
    }

    return this._parentElement;
  }

  getHref() {
    return this._element.href.match(/(#.+)/i)[0];
  }

  isActive() {
    return this._element.classList.contains(`${this._element.classList[0]}_active`);
  }

  setActive() {
    this._element.classList.add(`${this._element.classList[0]}_active`);
    this._element.tabIndex = -1;
  }

  reset() {
    this._element.classList.remove(`${this._element.classList[0]}_active`);
    this._element.tabIndex = null;
  }

  isScrolling() {
    return (this._element.dataset.scroll === `true`) ? true : false;
  }

  setClickHandler(callback) {
    this._callback.click = callback;
    this._element.addEventListener(`click`, this._clickHandler);
  }

  _clickHandler(evt) {
    this._callback.click(evt, this._index);
  }
}
